import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Spinner } from '@chilecompra/react-kit/components'
import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import { onGetTokenThunk } from './AuthorizationProvider.actions'
import AuthorizationContext from './AuthorizationProvider.context'
import { Root } from './AuthorizationProvider.styles'

/**
 * The Authorization Provider container.
 */
const AuthorizationProvider = ({ children }) => {
  const dispatch = useDispatch()
  const {
    accessToken,
    authInfo: { error: errorAuthInfo, isBuyer, isSeller, loading: loadingAuthInfo, userType },
    gettingToken
  } = useSelector(state => state.authorizationProvider)

  useEffectOnce(() => {
    if (accessToken === undefined) {
      dispatch(onGetTokenThunk())
    }
  })

  const isPrivate = useMemo(() => {
    return userType === '' ? undefined : userType === 'Comprador' || userType === 'Proveedor'
  }, [userType])

  if (!loadingAuthInfo && errorAuthInfo) {
    window.location.href = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`
    return null
  }

  if (!(accessToken && !gettingToken && userType && !loadingAuthInfo)) {
    return (
      <Root>
        <Spinner />
      </Root>
    )
  }

  return (
    <AuthorizationContext.Provider value={{ isBuyer, isSeller, isPrivate, userType }}>
      {children}
    </AuthorizationContext.Provider>
  )
}

AuthorizationProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default AuthorizationProvider
